(() => {
  angular
    .module('finance')
    .controller('finance.views.billingAccounts.viewHistory', 
      BillingAccountViewHistoryController
    );

  BillingAccountViewHistoryController.$inject = [
    '$stateParams',
    'abp.service.finance.billingAccount',
    'moment',
  ];

  function BillingAccountViewHistoryController(
    $stateParams,
    billingAccountSvc,
    moment
  ) {
    const vm = this;

    vm.loading = 0;
    vm.historyItems = [];

    const codeMirrorOptions = {
      lineNumbers: false,
      readOnly: true,
      mode: { name: 'javascript', json: true },
      highlightDifferences: true,
      connect: true,
      collapseIdentical: false,
      revertButtons: false,
      autoRefresh: true,
    };

    init();

    function init() {
      loadBillingAccountHistory();
    }

    function loadBillingAccountHistory() {
      vm.loading += 1;

      const payload = {
        id: $stateParams.id,
      };

      const httpParams = {
        headers: {
          Authorization: `Bearer ${App.getAccessToken()}`
        }
      };

      billingAccountSvc
        .getBillingAccountSnapshots(payload, httpParams)
        .success((data) => {
          const items = data.items || data;
          processHistoryItems(items);
          vm.historyItems = items;
        })
        .finally(() => {
          vm.loading -= 1;
        });
    }

    function processHistoryItems(items) {
      _.each(items, (historyItem, i) => {
        historyItem.snapshotTime = moment(historyItem.snapshotTime);

        const formattedJson = JSON.stringify(
          JSON.parse(historyItem.snapshotItemJson),
          null,
          2
        );
        historyItem.snapshotItemJson = formattedJson;

        const isLastItem = i === items.length - 1;
        const origJson = isLastItem
          ? ''
          : JSON.stringify(JSON.parse(items[i + 1].snapshotItemJson), null, 2);
        
        historyItem.showDiff = historyItem.snapshotItemJson !== origJson;

        if (historyItem.showDiff) {
          items[i].codeMirrorOptions = $.extend({}, codeMirrorOptions, {
            orig: origJson,
          });
        }
      });
    }
  }

})();
